import { motion } from 'framer-motion';
import { trustLogos } from '../../data/landingData';
import { fadeInUp, staggerContainer } from '../../utils/motion';

export function TrustSection() {
  return (
    <section className="bg-white py-8 sm:py-10">
      <div className="container-base">
        <motion.div
          className="rounded-3xl border border-slate-100 bg-canvas p-4 sm:p-6"
          variants={staggerContainer}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.3 }}
        >
          <p className="text-center text-xs font-semibold uppercase tracking-[0.2em] text-slate-500">
            Confían en +Trainer
          </p>
          <div className="mt-4 grid grid-cols-2 gap-3 sm:grid-cols-5">
            {trustLogos.map((logo) => (
              <motion.div
                key={logo}
                variants={fadeInUp}
                className="rounded-2xl border border-white bg-white px-3 py-2 text-center text-sm font-semibold text-slate-600 shadow-sm transition-colors hover:text-brand-600"
              >
                {logo}
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
